import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { PageTitle } from "../components/site/PageTitle";
import { useSite } from "../context/SiteContext";

export default function BlankApparel() {
  const { settings: s = {} } = useSite();
  const cats = [
    ["SanMar Catalog", "Browse blank apparel options including shirts, hoodies, polos, jackets, hats, bags, colors, and sizing.", s.sanmar_url, "Open SanMar", "sanmar"],
    ["S&S Activewear", "View additional blank apparel brands, garments, colors, sizes, and product options for custom orders.", s.ss_url, "Open S&S Activewear", "ss"],
  ];
  return (
    <div className="pb-20">
      <PageTitle badge="ASAP & Co." title="Blank Apparel" subtitle="Browse blank shirts, hoodies, hats, brands, colors, and sizes before placing your custom order." testId="blank-apparel-title" />
      <div className="mx-auto max-w-4xl px-6">
        <div className="panel p-6 text-center">
          <h2 className="red-title text-2xl">Need help choosing apparel?</h2>
          <p className="mt-2 text-sm text-slate-300">Use the catalogs below to find blank apparel options. Once you find a style, color, or item number you like, include it with your order request and we'll confirm availability and final pricing.</p>
        </div>
        <div className="mt-6 grid gap-6 md:grid-cols-2">
          {cats.map(([t, d, url, cta, id]) => (
            <a key={id} href={url} target="_blank" rel="noopener noreferrer" className="panel group block border-[#2563EB]/40 p-7 transition-transform duration-300 hover:-translate-y-1 hover:border-[#E5202A]" data-testid={`blank-apparel-${id}-link`}>
              <h3 className="font-display text-3xl font-black uppercase">{t}</h3>
              <p className="mt-2 text-sm text-slate-400">{d}</p>
              <span className="mt-5 inline-flex items-center gap-2 font-display text-lg font-bold uppercase text-[#E5202A]">{cta} <ExternalLink className="h-4 w-4" /></span>
            </a>
          ))}
        </div>
        <div className="mt-12 text-center">
          <h3 className="font-display text-3xl font-black uppercase">Ready To Start?</h3>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-slate-400">After choosing an item, send the style name, item number, color, size, quantity, and artwork so we can review availability and prepare your order.</p>
          <Link to="/order" className="btn-red mt-6" data-testid="blank-apparel-start-order-button">Start Custom Order</Link>
        </div>
      </div>
    </div>
  );
}
